export const messages = {
  en: {
    storeOrderCartManage: {
      searchCondition: 'Search Condition',
      orderNumber: 'Order Number',
      selectStatus: 'Select Status',
      notPurchased: 'Not Purchased',
      waitDeliver: 'Waiting for Delivery',
      waitReceive: 'Waiting for Receiving',
      waitComment: 'Waiting for Comment',
      applyRefund: 'Apply for Refund',
      returnSuccess: 'Return Success',
      refunded: 'Refunded',
      productName: 'Product Name',
      search: 'Search',
      orderInfo: 'Order Information',
      platform: 'Platform',
      shop: 'Shop',
      type: 'Type',
      service: 'Service',
      product: 'Product',
      name: 'Name',
      quantity: 'Quantity',
      userName: 'User Name',
      paymentAmount: 'Payment Amount',
      orderStatus: 'Order Status',
      createTime: 'Create Time',
      operation: 'Operation',
      detail: 'Detail',
      all: 'All'
    }
  },
  zh: {
    storeOrderCartManage: {
      searchCondition: '查询条件',
      orderNumber: '订单编号',
      selectStatus: '请选择状态',
      notPurchased: '未购买',
      waitDeliver: '待发货',
      waitReceive: '待收货',
      waitComment: '待评价',
      applyRefund: '申请退款',
      returnSuccess: '退货成功',
      refunded: '已退款',
      productName: '请输入商品名称',
      search: '查询',
      orderInfo: '订单信息',
      platform: '平台',
      shop: '商铺',
      type: '类型',
      service: '服务',
      product: '商品',
      name: '名称',
      quantity: '数量',
      userName: '用户名称',
      paymentAmount: '支付金额',
      orderStatus: '订单状态',
      createTime: '创建时间',
      operation: '操作',
      detail: '详情',
      all: '全部'
    }
  }
}